<template>
    <div class="file-uploader">
        <button v-if="! enabled" @click.prevent="enableFilesUpload"
                class="button is-primary is-small" v-text="lang('Allega file')"></button>
        <div v-if="enabled" class="file-inputs">
            <div class="title">
                <span v-text="lang('Carica file')"></span>
                <span @click.prevent="addFile" class="add-input"><span class="icon"><i class="fas fa-plus-circle"></i></span> {{ lang('Aggiungi file') }}</span>
            </div>
            <file-upload v-for="(file, index) in files"
                         :key="index" :file="file" :index="index" @selected="selectFile"
                         @remove="removeFile"></file-upload>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                enabled: false,
                files: [
                    {
                        id: 0,
                        name: 'attachments[]'
                    }
                ],
                fileList: {}
            }
        },
        methods: {
            enableFilesUpload() {
                this.enabled = true
            },
            addFile() {
                this.files.push( {id: this.files.length, name: 'attachments[]'} )
            },
            selectFile( file, index ) {
                this.fileList[index] = file;
            },
            removeFile( index ) {
                if( this.files.length > 1 ) {
                    this.files.splice( index, 1 );
                    delete this.fileList[index];
                }
            }
        }
    }
</script>